export default __webpack_public_path__ + "static/learn2-13f973d4eba0e3805b6ce4ec852e9bf8.mp4";